/**
 * mSTEM pill badge primitive. Used for:
 *   - admin role indicator (DG-06): variant="admin" → purple background
 *   - table status badges: variant="success|warning|info|danger"
 *   - generic primary badge: variant="primary" (default)
 *
 * Exports VARIANT_CLASS as a named export so tests can verify the
 * variant-to-class mapping without depending on the (mocked) CSS module
 * hash at test time.
 *
 * Security note (T-02-01-05): children render via React text — auto-escaped.
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './mstem-badge.css';

const VARIANT_CLASS = {
    primary: 'badgePrimary',
    success: 'badgeSuccess',
    warning: 'badgeWarning',
    danger: 'badgeDanger',
    info: 'badgeInfo',
    admin: 'badgeAdmin'
};

const MstemBadge = ({variant, children, className}) => {
    const variantKey = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
    return (
        <span
            className={classNames(styles.badge, styles[variantKey], className)}
        >
            {children}
        </span>
    );
};

MstemBadge.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'success', 'warning', 'danger', 'info', 'admin'])
};

MstemBadge.defaultProps = {
    variant: 'primary'
};

export {
    MstemBadge as default,
    VARIANT_CLASS
};
